module.exports = __webpack_public_path__ + "img/geology-neptune.e79d4398.png";